import React from 'react'
import RowList from '../components/Main/RowList'
import Page from '../components/Page'
import ButtonTextCard from '../components/Main/ButtonTextCard'
import PartnerLogos from '../components/Main/PartnerLogos'
import CtaBanner from '../components/Main/CtaBanner'

export default function Partners (props) {
  const {
    //Partner Intro Fields
    partners_subheading: partnersSubheading,
    partners_heading: partnersTitle,
    partners_intro_paragraph: partnersIntro,
    partners_tier_2_heading: tierTwoHeading,

    //Partner Tier Repeaters
    partners_tier_1: tierOne,
    partners_tier_2: tierTwo,
    partners_tier_3: tierThree,

    //CtaBanner
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <React.Fragment>
      <Page title={partnersTitle} body={partnersIntro} slug={'/partners'}>
        <main id='content'>
          <div className='container-fluid partners'>
            <RowList
              partners
              title={partnersTitle}
              subheading={partnersSubheading}
              body={partnersIntro}
            />
            <ButtonTextCard content={tierOne} />
            <div style={{width: '75%', height: '1px', backgroundColor: '#4e87a0', margin: '4rem auto 7rem'}}></div>
            <ButtonTextCard content={tierTwo} />
            <div style={{width: '75%', height: '1px', backgroundColor: '#4e87a0', margin: '4rem auto 7rem'}}></div>
            <ButtonTextCard content={tierThree} />
            <div style={{width: '100%', height: '1px', margin: '6rem auto 0'}}></div>
          </div>

        </main>
        <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      </Page>
    </React.Fragment>
  )
}
